export default (componentType, index) => `comp_${componentType}_${index}`;
